import { render, staticRenderFns } from "./gridComercial.vue?vue&type=template&id=6f5d32b4&"
import script from "./gridComercial.vue?vue&type=script&lang=js&"
export * from "./gridComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports